import React, { useEffect, useMemo } from 'react';
import { FiAward, FiBarChart2, FiCheckCircle, FiClock, FiX } from 'react-icons/fi';
import { formatKoreanDate, formatMinutes } from '../utils/dateUtils';

const DailyReportModal = ({ onClose, plans, report, selectedDate }) => {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => event.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const insight = useMemo(() => {
    const lowestPlan = [...plans]
      .filter((plan) => Number(plan.understanding) > 0)
      .sort((a, b) => Number(a.understanding) - Number(b.understanding))[0];
    if (lowestPlan && Number(lowestPlan.understanding) <= 2) {
      return `${lowestPlan.subject} 이해도가 낮게 기록되었습니다. 내일 첫 학습으로 복습해 보세요.`;
    }
    if (Number(report.actualMinutes) > Number(report.plannedMinutes)) {
      return '계획보다 충분한 시간을 학습했습니다. 내일은 같은 흐름을 유지해 보세요.';
    }
    return '오늘 계획을 모두 완료했습니다. 이해도가 낮은 내용을 짧게 복습하면 더 좋습니다.';
  }, [plans, report]);

  return (
    <div className="scheduler-report-modal" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="scheduler-report" role="dialog" aria-modal="true" aria-labelledby="scheduler-report-title">
        <header>
          <span><FiAward aria-hidden="true" /></span>
          <div>
            <h2 id="scheduler-report-title">일일 학습 리포트</h2>
            <p>{formatKoreanDate(selectedDate)}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="닫기"><FiX aria-hidden="true" /></button>
        </header>

        <section className="scheduler-report__result">
          <FiCheckCircle aria-hidden="true" />
          <div><strong>오늘의 계획을 모두 완료했어요!</strong><span>꾸준한 학습 흐름을 잘 만들었습니다.</span></div>
        </section>

        <div className="scheduler-report__stats">
          <article><FiBarChart2 aria-hidden="true" /><span>완료율</span><strong>{report.completionRate}%</strong></article>
          <article><FiClock aria-hidden="true" /><span>계획 시간</span><strong>{formatMinutes(report.plannedMinutes)}</strong></article>
          <article><FiClock aria-hidden="true" /><span>실제 시간</span><strong>{formatMinutes(report.actualMinutes)}</strong></article>
          <article><FiAward aria-hidden="true" /><span>평균 이해도</span><strong>{Number(report.averageUnderstanding || 0).toFixed(1)}</strong></article>
        </div>

        <section className="scheduler-report__detail">
          <h3>학습 기록</h3>
          {plans.map((plan) => (
            <article key={plan.sno}>
              <span>{plan.subject}</span>
              <div><strong>{plan.planContent}</strong><small>{plan.actualContent}</small></div>
              <em>{'★'.repeat(Number(plan.understanding) || 0)}</em>
            </article>
          ))}
        </section>

        <section className="scheduler-report__insight">
          <span><FiAward aria-hidden="true" /> 오늘의 추천</span>
          <p>{insight}</p>
        </section>

        <button type="button" className="scheduler-report__close" onClick={onClose}>확인</button>
      </section>
    </div>
  );
};

export default DailyReportModal;
